import {Provider} from "@angular/core";
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {
    IntegrationTypeFullComponent
} from "../component/object-components/integration-type-object-base-component/view/full/integration-type-full.component";
import {HcConfigPage} from "../page/overview/hc-config/hc-config.page";
import {
    IntegrationAdapterTypeObjectBaseComponent
} from "../component/object-components/integration-adapter-type-object-base-component/integration-adapter-type-object-base.component";
import {
    IntegrationAdapterTypeSideComponent
} from "../component/object-components/integration-adapter-type-object-base-component/view/side/integration-adapter-type-side.component";
import {
    IntegrationAdapterTypeFullComponent
} from "../component/object-components/integration-adapter-type-object-base-component/view/full/integration-adapter-type-full.component";
import {
    IntegrationTypeObjectBaseComponent
} from "../component/object-components/integration-type-object-base-component/integration-type-object-base.component";
import {
    IntegrationTypeSideComponent
} from "../component/object-components/integration-type-object-base-component/view/side/integration-type-side.component";


const hcModuleEntry: TestModuleDefinition = {
    key: 'hc',
    label: 'Integration (hc)',
    components: [
        {
            key: 'IntegrationAdapterTypeObjectBaseComponent',
            component: IntegrationAdapterTypeObjectBaseComponent,
            selector: 'hc-integration-adapter-object-base-component',
            type: 'ObjectBaseComponent',
            label: 'integration adapter type object base component'
        },
        {
            key: 'IntegrationAdapterTypeSideComponent',
            component: IntegrationAdapterTypeSideComponent,
            selector: 'hc-integration-adapter-side-component',
            type: 'IntegrationAdapterTypeBaseComponent',
            label: 'integration adapter type side component'
        },
        {
            key: 'IntegrationAdapterTypeFullComponent',
            component: IntegrationAdapterTypeFullComponent,
            selector: 'hc-integration-adapter-full-component',
            type: 'IntegrationAdapterTypeBaseComponent',
            label: 'integration adapter type full component'
        },
        {
            key: 'IntegrationTypeObjectBaseComponent',
            component: IntegrationTypeObjectBaseComponent,
            selector: 'hc-integration-object-base-component',
            type: 'ObjectBaseComponent',
            label: 'integration type object base component'
        },
        {
            key: 'IntegrationTypeSideComponent',
            component: IntegrationTypeSideComponent,
            selector: 'hc-integration-side-component',
            type: 'IntegrationTypeBaseComponent',
            label: 'integration type side component'
        },
        {
            key: 'IntegrationTypeFullComponent',
            component: IntegrationTypeFullComponent,
            selector: 'hc-integration-full-component',
            type: 'IntegrationTypeBaseComponent',
            label: 'integration type full component'
        },
        {
            key: 'HcConfigPage',
            component: HcConfigPage,
            selector: 'mvs-hc-config',
            type: 'PageComponent',
            label: 'hc config page'
        }
    ]
}

export const HC_TEST_PROVIDERS: Provider[] = [
    {provide: TEST_MODULE_REGISTRY, useValue: hcModuleEntry, multi: true}
];